import { CancelToken, isCancel } from 'axios'

const getDefaultState = () => {
  return {
    // Flags currently visible
    active: [],
    // What filters are currently applied
    filters: {},
    // Used to indicate when waiting on the server
    loading: false,
    // The current page being viewed
    page: 1,
    // Size of current page beign viewed
    rowsPerPage: 25,
    // The search string being applied
    search: '',
    // Sorting
    sort: {
      by: 'createdAt',
      descending: false,
    },
    // Token source used to abandon requests
    source: null,
    // The total records matching the filter according to the server (for pagination)
    total: 0,
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),

  //   getters: { },

  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'updatedAt', descending: true },
        filters = {},
      }
    ) {
      state.search = search
      state.active = items.map(i => ({ ...i, $type: 'Flag' }))
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
      state.selected = []
    },
    remove(state, id) {
      state.active = state.active.filter(flag => flag.id !== id)
    },
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
  },

  actions: {
    abandon({ state }, reason) {
      if (state.source) {
        state.source.cancel(reason)
        state.source = null
        state.loading = false
      }
    },

    resetState({ commit }) {
      commit('resetState')
    },

    search(
      { commit, state },
      { descending, filters, opportunity = Vue.$route.params.id, page, rowsPerPage, sortBy } = {}
    ) {
      this.$authorize('list', 'Flag')

      // Cancel previous search actions
      if (state.source) {
        state.source.cancel()
      }
      state.source = CancelToken.source()
      descending = typeof descending === 'boolean' ? descending : state.sort.descending
      state.filters = filters || state.filters
      page = page || state.page
      const per = rowsPerPage || state.rowsPerPage
      sortBy = sortBy || state.sort.by
      const sort = `${sortBy} ${descending ? 'DESC' : 'ASC'}`

      state.loading = true
      return Vue.$http
        .get('admin/flags', {
          params: { ...state.filters, page, sort, per },
          cancelToken: state.source.token,
        })
        .then(
          response => commit('setActive', response.data),
          errors => {
            if (!isCancel(errors)) state.loading = false
          }
        )
    },

    create({ }, flag) {
      this.$authorize('create', 'Flag')

      return Vue.$http.post('admin/flags', { ...flag }).then(
        ({ data }) => data,
        error => {
          throw error
        }
      )
    },

    destroy({ commit }, flag) {
      this.$authorize('delete', 'Flag')

      return Vue.$http.delete(`admin/flags/${flag.id}`).then(response => commit('remove', flag.id))
    },
  },
}
